// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RequiredFields_wrapper__2zcJk","asterisk":"RequiredFields_asterisk__3ge_6"};